interface CertificationDisclaimerProps {
  variant?: "default" | "compact";
  className?: string;
}

export default function CertificationDisclaimer({
  variant = "default",
  className = "",
}: CertificationDisclaimerProps) {
  const base = "rounded-md border border-amber-200 bg-amber-50 text-amber-900";
  const padding =
    variant === "compact" ? "px-3 py-2 text-xs" : "px-4 py-3 text-sm";
  return (
    <div className={`${base} ${padding} ${className}`.trim()}>
      <p className="leading-relaxed">
        <strong>Aviso legal:</strong> Las certificaciones emitidas por la
        Academia son titulaciones propias de formación privada. Están orientadas
        a fortalecer competencias profesionales, mejorar la empleabilidad y
        aportar valor curricular en entornos empresariales. No equivalen a
        títulos oficiales del sistema educativo costarricense ni se encuentran
        homologadas por el Ministerio de Educación Pública de Costa Rica, salvo
        indicación expresa en contrario.
      </p>
    </div>
  );
}
